import angular from "angular";
import { Popover } from "bootstrap";

/**
 * Fires the necessary Bootstrap 5 initialization for the given element.
 * @example
 * ```html
 * <a href="#" sxy-bs5-popover data-bs-toggle="popover" data-bs-title="Default popover">inline links</a>
 * ```
 */
export class Bs5Popover implements angular.IDirective {

    /**
     * Factory for directive registration.
     * @ignore
     */
    public static salaxyBs5Popover() {
      const factory = () => new Bs5Popover();
      factory.$inject = [];
      return factory;
    }

    /**
     * Applies to attributes only.
     * @ignore
     */
    public restrict = "A";

   /**
    * Creates a new instance of the directive.
    */
    constructor() {}

   /**
    * Attaches the appropriate Bootstrap scripts to the element.
    * @ignore
    */
    public link(scope: any, element: JQLite, attrs: any) {
      const title = scope.$eval(attrs.bsTitle);
      const content = "<div>" + scope.$eval(attrs.bsContent) + "</div>";
      const placement = scope.$eval(attrs.bsPlacement) || "right";
      new Popover(element[0], {
        title: title,
        content: content,
        placement: placement,
        trigger: "focus"
      });
    }
}
